import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImageAvatarService {
  baseApi = environment.oldApi;

  getImagePhotoUrl(uid: string): string {
    const baseImageURL = this.baseApi + '/images'
    let sender_id = '';
    if (uid.includes('bot_')) {
      sender_id = uid.slice(4)
    } else {
      sender_id = uid
    }
    return baseImageURL + '?path=uploads/users/' + sender_id + '/images/photo.jpg'
  }

}